<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box form-inline">
          <div class="box-body">
            <div class="row">
              <div class="col-sm-6 text-left">
                <div class="form-group text-left">
                  <router-link :to="'/printerInfo/' + $route.params.printer_id">
                    <div class="btn btn-default btn-table-title">返回出單機資訊</div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">出單機名稱(ID)</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">綁定名稱(ID)</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">類型</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">辨識碼</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">出單機啟用</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">綁定機啟用</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(printer, index) in printerList">
                    <!-- cloumn 0 -->
                    <td class="sorting_1">{{index + 1}}</td>
                    <td>
                      出單機{{printer.printer_id}}號 ({{printer.printer_id}})
                    </td>
                    <td>
                      {{printer.binding_name}} ({{printer.binding_id}})
                    </td>
                    <td>{{printerType(printer.printer_type)}}</td>
                    <td>{{printer.printer_identity}}</td>
                    <td>
                      <span v-if="printer.printer_is_enabled" class="label label-success">啟用</span>
                      <span v-if="!printer.printer_is_enabled"  class="label label-danger">未啟用</span>
                    </td>
                    <td>
                      <span v-if="printer.binding_is_enabled" class="label label-success">啟用</span>
                      <span v-if="!printer.binding_is_enabled"  class="label label-danger">未啟用</span>
                    </td>
                    <td>
                      <router-link :to="'/upPrinterStore/' + printer.printer_id + '/' + printer.binding_id">
                        <button class="btn btn-default"><i class="fa fa-pencil"></i></button>
                      </router-link>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import mqttTable from './Temp/MqttTableTemp.vue'
export default {
  name: 'Tables',
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      searchResult: '',
      printerList: []
    }
  },
  mounted () {
  },
  components: {
    'mqtt-table': mqttTable
  },
  methods: {
    printerType (type) {
      switch (type) {
        case 1: return '熒埔'
        case 2: return '飛鵝'
      }
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getPrinterList()
    },
    getPrinterList () {
      var self = this
      var url = '/printer/storePrinterList/' + this.$route.params.store_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerList = response.data.list
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    this.fixedH()
    this.getPrinterList()
  }
}
</script>



// WEBPACK FOOTER //
// PrinterStoreTable.vue?5a7d1bc2